import { measureText } from '../measure-text'
import { BoxConstraints, DrawOp, Font, RenderBox, TextAlign, useRenderBox } from '../rendering'

type TextProps = {
  text: string
  font: Font
  color: string
  lineHeight: number
  textAlign: TextAlign
}

class TextRenderBox extends RenderBox<TextProps> {
  performLayout({ minWidth, maxWidth }: BoxConstraints) {
    const { width: natural, height } = measureText(this.props.text, {
      font: this.props.font,
      lineHeight: this.props.lineHeight,
      kerning: false
    })

    this.box = {
      x: 0,
      y: 0,
      // Clamp width to incoming constraints
      width: Math.max(minWidth, Math.min(natural, maxWidth)),
      height: height
    }
  }

  draw(): DrawOp {
    return {
      type: 'text',
      id: this.id,
      bounds: this.box,
      text: this.props.text,
      font: this.props.font,
      color: this.props.color,
      line_height: this.props.lineHeight,
      kerning: false,
      text_align: this.props.textAlign // convey alignment intent to renderer
    }
  }
}

export function Text({
  children,
  fontSize = 14,
  fontFamily = 'Helvetica',
  fontWeight = 'normal',
  color = '#000000',
  lineHeight = 1.0,
  textAlign = 'left'
}: {
  children: string
  fontSize: number
  fontFamily?: string
  fontWeight?: Font['weight']
  color?: string
  lineHeight?: number
  textAlign?: TextAlign
}) {
  useRenderBox(() => {
    return new TextRenderBox({
      text: children,
      font: { size: fontSize, family: fontFamily, weight: fontWeight },
      color: color,
      lineHeight: lineHeight,
      textAlign: textAlign
    })
  }, [children, fontSize, fontFamily, fontWeight, color, lineHeight, textAlign])
  return null // nothing for DOM; canvas will draw
}
